import { useEffect, useState } from 'react'
import { LifeBuoy } from 'lucide-react'
import { supabase, isDemoMode } from '../lib/supabase'
import { getActiveCompanyId } from '../lib/session'

// Client-facing help page. Content lives in brand_settings.client_help_html
// (per brand profile) and is editable from Settings → Client help.
export default function Help() {
  const [html, setHtml] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (isDemoMode) {
      setHtml('<p class="text-gray-500">Supabase isn\'t configured.</p>')
      setLoading(false)
      return
    }
    const companyId = getActiveCompanyId()
    supabase.rpc('get_active_brand', { p_company_id: companyId })
      .then(({ data }) => {
        setHtml(data?.client_help_html || '<p>No help content has been added yet. Please contact your account manager.</p>')
        setLoading(false)
      })
  }, [])

  return (
    <div className="space-y-4 max-w-3xl">
      <div className="card">
        <h3 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
          <LifeBuoy className="w-5 h-5 text-brand" />
          How to place an order
        </h3>
        {loading
          ? <p className="text-sm text-gray-500">Loading…</p>
          : <div
              className="prose prose-sm max-w-none
                [&_h3]:text-brand-dark [&_h3]:font-semibold [&_h3]:text-lg [&_h3]:mt-8 [&_h3]:mb-3 [&_h3:first-child]:mt-0
                [&_p]:my-3 [&_p]:leading-relaxed [&_p]:text-gray-700
                [&_ol]:my-3 [&_ol]:space-y-2 [&_ul]:my-3 [&_ul]:space-y-2
                [&_li]:leading-relaxed [&_li]:text-gray-700
                [&_a]:text-brand-dark [&_a]:underline hover:[&_a]:text-brand
                [&_strong]:text-gray-900"
              dangerouslySetInnerHTML={{ __html: html }} />
        }
      </div>
    </div>
  )
}
